import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';
import EmailAiPromptsEditor from './EmailAiPromptsEditor';

const AiPromptsPage: React.FC = () => {
  const { colors } = useTheme();

  return (
    <div className={cn('flex flex-col flex-1 min-h-0 min-w-0', colors.background)}>
      <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden dashboard-scrollbar">
        <div className="p-4 sm:p-6 w-full min-h-0">
          <EmailAiPromptsEditor />
        </div>
      </div>
    </div>
  );
};

export default AiPromptsPage;
